module.exports = __webpack_public_path__ + "img/icon-box-48.71303697.svg";